import type { GameRosterPlayer } from '../types'

/**
 * Roster players vs spares. A spare is an affiliate — the same split the
 * mobile Game Setup roster uses.
 */
export const splitRosterPlayers = (
  players: GameRosterPlayer[]
): { regulars: GameRosterPlayer[]; spares: GameRosterPlayer[] } => ({
  regulars: players.filter((player) => !player.is_affiliate),
  spares: players.filter((player) => !!player.is_affiliate),
})
